<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="164" height="164" viewBox="0 0 164 164">
        <defs>
            <filter id="Ellipse_919-2" x="8" y="8" width="148" height="148" filterUnits="userSpaceOnUse">
                <feOffset input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="8" result="blur"/>
                <feFlood class="svg-flood-primary-color" flood-opacity="0.322"/>
                <feComposite operator="in" in2="blur"/>
                <feComposite in="SourceGraphic"/>
            </filter>
            <clipPath id="clip-Expired_document">
                <rect width="164" height="164"/>
            </clipPath>
        </defs>
        <g id="Expired_document" data-name="Expired document" clip-path="url(#clip-Expired_document)">
            <rect width="164" height="164" fill="#fff"/>
            <g id="Group_14925" data-name="Group 14925" transform="translate(14979 586)">
                <g id="Group_14922" data-name="Group 14922" transform="translate(-14683 -493.5)">
                    <g transform="matrix(1, 0, 0, 1, -296, -92.5)" filter="url(#Ellipse_919-2)">
                        <circle id="Ellipse_919-2-2" data-name="Ellipse 919-2" cx="50" cy="50" r="50" transform="translate(32 32)" fill="#fff"/>
                    </g>
                </g>
                <g id="Group_14895-2" data-name="Group 14895-2" transform="translate(-14683 -493.5)">
                    <path id="Path_4457" class="svg-primary-color" data-name="Path 4457" d="M-216-18.5v10l8.56,5.08L-206-5.84-213-10v-8.5Zm2-12a19.93,19.93,0,0,0-15.974,8.026L-235-27.5v12h12l-4.833-4.833A16.959,16.959,0,0,1-214-27.5a17.019,17.019,0,0,1,17,17,17.019,17.019,0,0,1-17,17,17.018,17.018,0,0,1-16.872-15H-233.9A20.027,20.027,0,0,0-214,9.5a20.023,20.023,0,0,0,20-20A20.023,20.023,0,0,0-214-30.5Z" />
                </g>
                <g id="Group_14923" data-name="Group 14923" transform="translate(-14683 -493.5)">
                    <path id="Path_4458" class="svg-primary-color" data-name="Path 4458" d="M-214,71.5a82.093,82.093,0,0,1-82-82,82.093,82.093,0,0,1,82-82,82.093,82.093,0,0,1,82,82A82.093,82.093,0,0,1-214,71.5Zm0-163a81.091,81.091,0,0,0-81,81,81.092,81.092,0,0,0,81,81,81.092,81.092,0,0,0,81-81A81.091,81.091,0,0,0-214-91.5Z" opacity="0.08"/>
                </g>
                <g id="Group_14924" data-name="Group 14924" transform="translate(-14683 -493.5)">
                    <path id="Path_4459" class="svg-primary-color" data-name="Path 4459" d="M-214,55.5a66.074,66.074,0,0,1-66-66,66.074,66.074,0,0,1,66-66,66.074,66.074,0,0,1,66,66A66.074,66.074,0,0,1-214,55.5Zm0-131a65.074,65.074,0,0,0-65,65,65.074,65.074,0,0,0,65,65,65.074,65.074,0,0,0,65-65A65.074,65.074,0,0,0-214-75.5Z"  opacity="0.08"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "expiredDocument",
        computed: {
            ...mapGetters({
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/expiredDocument.vue